// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountCreatingPoster_container_Vir6J","logo":"AccountCreatingPoster_logo_2XagB","information":"AccountCreatingPoster_information_2bTXB"};